import React from 'react';
import SharedProjectList from '../Admin-Pages/SharedProjectList';
import './vStyles/VolunteerProjects.css';

const VolunteerProjects: React.FC = () => {
  return (
    <div className="volunteer-projects-page">
      <div className="volunteer-projects-header">
        <h1>Available Projects</h1>
        <p>Join exciting projects and make a difference in your community</p>
      </div>
      
      <SharedProjectList 
        isAdmin={false}
        showCreateButton={false}
        className="volunteer-projects-container"
      />
    </div>
  );
};

export default VolunteerProjects;